import React from "react";
import styles from "./NavBarEvent.module.css";

const NavBarEvent = ({ logoUrl, bgColor = "#303030" }) => {
  return (
    <div
      className={styles.container}
      style={{
        backgroundColor: bgColor ? bgColor : "#000000",
        height: 70,
        padding: "10px 0",
        position: "fixed"
      }}
    >
      <div style={{ height: "60%", objectFit: "contain", marginLeft: 20 }}>
        <img style={{ maxHeight: "50px", borderRadius: "5px" }} src={logoUrl} alt="" />
      </div>
    </div>
  );
};

export default NavBarEvent;
